import { useContext } from "react";

import WizardContext from "../WizardContext";
import { WizardContextType } from "../types/WizardContextType";

const useWizardContext = (): WizardContextType => useContext(WizardContext);

export default useWizardContext;
